import { API_END_POINTS } from '@/shared/api/end-points'
import { legacyAuthRequest } from './legacy-auth-request'

type LegacySigninPayload = {
  loginEmail: string
  loginPassword: string
  action: 'signin'
}

const signinLegacy = async (payload: LegacySigninPayload) => {
  return legacyAuthRequest<{ api_token?: string; user?: { email?: string } }>(API_END_POINTS.auth.login, {
    method: 'POST',
    body: new URLSearchParams(payload),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export default signinLegacy
